import {Directive, Input, OnChanges, SimpleChange, SimpleChanges} from '@angular/core';
import {NgForOf} from '@angular/common';

@Directive({
    selector: '[ngFor][ngForIn]'
})
export class NgForInDirective<T> extends NgForOf<T> implements OnChanges {

    @Input() ngForIn: any;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.ngForIn) {
            this.ngForOf = Object.keys(this.ngForIn) as Array<any>;
        }
    }
}
